// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"e34adc82","525":"7976e41b","632":"a59233b2","926":"de0c4ce9","989":"62115cab"}[chunkId] + ".chunk.js";
};